


































































import Vue from "vue";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import UserModel, { UserRole } from "@/models/User";
import EventBus, { DeclaredEvents, SnackBarEvent, RequestSingleChatControllerEvent } from "@/EventBus";
import MainChatsController from "@/components/Chat/MainChatsController";
import _debug from "debug";

const debug = _debug("Mediacao:App.vue");

const userModule = getModule(UserModule, store);

export interface MenuItem {
    icon?: string;
    text?: string;
    path?: string;
    divider?: boolean;
    roles?: UserRole[];
}

@Component
export default class App extends Vue {
    private drawer = false;
    private snackbar = false;
    private snackbarColor = "primary";
    private snackbarTimeout = 4000;
    private snackbarMessage = "";
    private snackbarActionButtonClick: (() => void) | null = null;
    private snackbarActionButtonText: string | null = null;
    private mainChatsController: MainChatsController = new MainChatsController();

    private items: MenuItem[] = [];
    private itemsOriginal: MenuItem[] = [
        { icon: "mdi-folder-home", text: "Início", path: "/" },
        {
            icon: "mdi-folder-heart",
            text: "Meus Processos",
            roles: ["admin", "mediador"],
            path: "/processos",
        },
        {
            icon: "mdi-folder-open",
            text: "Solicitações Abertas",
            roles: ["admin", "mediador"],
            path: "/solicitacoes",
        },
        {
            icon: "mdi-folder-multiple",
            text: "Todos os Processos",
            roles: ["admin"],
            path: "/processos-todos",
        },
        { divider: true },
        {
            icon: "mdi-account",
            text: "Usuários",
            path: "/users",
            roles: ["admin"],
        },
        { icon: "mdi-settings", text: "Configurações", path: "/settings", roles: ["admin"] },
        { icon: "mdi-location-exit", text: "Sair", path: "/logout" },
    ];
    private accountMenu: MenuItem[] = [
        {
            icon: "mdi-account-edit",
            text: "Meus dados",
            path: "/users/cadastro?modo=proprio",
        },
        { icon: "mdi-location-exit", text: "Sair", path: "/logout" },
    ];
    private authenticated = false;
    private menuDoUsuario: MenuItem[] = [{ icon: "mdi-location-enter", text: "Entrar", path: "/login" }];
    private theUser?: UserModel;

    private created() {
        this.$store.subscribe(async (mutation, state) => {
            debug("App.Store.subscribe:", mutation, state);
            if (mutation.type === "setLoadingUser" && this.theUser) {
                this.theUser = await state.UserModule.user;
                debug("The user on setLoading", this.theUser);
                if (this.theUser && this.theUser.userDb) {
                    this.mainChatsController.watchChats();
                }
            }
        });
        EventBus.$on(DeclaredEvents.snackBarMessage, (snackbarEvent: SnackBarEvent) => {
            this.snackbarColor = snackbarEvent.priority;
            this.snackbarTimeout = snackbarEvent.timeout ? snackbarEvent.timeout : 4000;
            this.snackbarMessage = snackbarEvent.message;
            this.snackbarActionButtonText = snackbarEvent.actionButtonText ? snackbarEvent.actionButtonText : null;
            if (snackbarEvent.actionButtonRoute) {
                this.snackbarActionButtonClick = () => {
                    this.$router.push(snackbarEvent.actionButtonRoute as string);
                };
            }
            this.snackbar = true;
        });

        EventBus.$on(DeclaredEvents.requestSingleChatController, (requestChat: RequestSingleChatControllerEvent) => {
            const chatController = this.mainChatsController.getSingleChatControllerById(requestChat.id);
            if (chatController) {
                requestChat.callBack(chatController);
            }
        });

        EventBus.$on(DeclaredEvents.logout, () => {
            this.theUser = undefined;
            debug("App.logout!");
            this.menuDoUsuario = this.filterMenuItemsByRole(undefined);
            this.mainChatsController.closeAll();
        });

        EventBus.$on(DeclaredEvents.login, (user: UserModel) => {
            this.theUser = user;
            debug("App.login!", user);
            if (this.theUser) {
                this.menuDoUsuario = this.filterMenuItemsByRole(this.theUser);
            }
            this.mainChatsController.watchChats();
        });
    }

    private filterMenuItemsByRole(theUser?: UserModel): MenuItem[] {
        let filteredItems: MenuItem[] = [{ icon: "mdi-location-enter", text: "Entrar", path: "/login" }];
        if (theUser) {
            let existingUser = theUser;
            if (typeof theUser.hasRoleOf !== "function") {
                existingUser = Object.assign(UserModel.empty(), existingUser);
            }
            filteredItems = this.itemsOriginal.filter(item => {
                if (item.roles) {
                    return existingUser.hasRoleOf(item.roles);
                } else {
                    return true;
                }
            });

            if (existingUser.hasRoleOf(["admin", "mediador"])) {
                filteredItems.some(item => {
                    if (item.path === "/") {
                        item.path = "/processos";
                        return true;
                    }
                });
            }
        }
        debug("App.filterMenuItemsByRole: Menu Itens filtrados por Role", filteredItems);
        return filteredItems;
    }

    private get user() {
        return userModule.getUser;
    }

    private get userPhotoURL() {
        let url = "";
        if (this.user) {
            url = this.user.photoURL;
        }
        debug("photoURL", url);
        return url;
    }
    private get noUserLogged() {
        return this.user ? false : true;
    }
}
